import { formatCurrencyWhole } from '../utils/api';
import Modal from './Modal';
import { formatDateShort } from '../utils/dateFormat';
import CreditCloseReasonPicker from './CreditCloseReasonPicker';
import Icon from './Icon';

// "Mark as received", with the optional link to the credit document that
// settles it. Shared by both credits pages: /credits receives an open credit,
// /credits/history re-receives a cancelled one, and the dialog is identical in
// both — it was duplicated verbatim in the two pages until this was extracted.
//
// `modal` is the page's own `{ credit, candidateDocs, selectedDocId, reason,
// note }` state; `onSelectDoc(id)` updates the picked document,
// `onSetReason(key)` / `onSetNote(text)` the close reason, `onConfirm` commits.
//
// The document link stays OPTIONAL, as it always was — but choosing not to link
// one now has to say why, since that is the close that leaves no trace anywhere
// else. Picking a document makes the chips disappear entirely: the document IS
// the record. The two inputs are therefore mutually exclusive by construction,
// not by a validation message.
export default function CreditReceiveModal({ modal, onSelectDoc, onSetReason, onSetNote, onConfirm, onClose }) {
  const needsReason = !modal.selectedDocId;
  const canConfirm  = !needsReason || Boolean(modal.reason);

  return (
    <Modal onClose={onClose} title="סמן כהתקבל" size={520} closeOnBackdrop={false}>
    <div style={{ background: 'var(--tint)', borderRadius: 10, padding: '12px 16px', marginBottom: 20 }}>
      <div style={{ fontWeight: 700, marginBottom: 4 }}>{modal.credit.supplier_name}</div>
      <div style={{ fontSize: '0.88rem', color: 'var(--ink-muted)' }}>
        {modal.credit.item_description}
        {modal.credit.item_sku && <span style={{ color: 'var(--ink-subtle)' }}> — מק"ט: {modal.credit.item_sku}</span>}
      </div>
      <div style={{ marginTop: 6, fontWeight: 700, color: 'var(--warning-ink)' }}>
        כמות: {modal.credit.credit_qty} | סך הכל: {formatCurrencyWhole(modal.credit.credit_total)} (ללא מע״מ)
      </div>
    </div>

    <div className="form-group">
      <label>קישור לחשבונית זיכוי / תעודת החזרה (אופציונלי)</label>
      <select className="form-control" value={modal.selectedDocId}
        onChange={e => onSelectDoc(e.target.value)}>
        <option value="">— ללא קישור —</option>
        {modal.candidateDocs.length === 0 && (
          <option disabled>אין מסמכי זיכוי עבור ספק זה</option>
        )}
        {modal.candidateDocs.map(d => (
          <option key={d.id} value={d.id}>
            {d.doc_type} — {d.doc_num || '#' + d.id} — {formatDateShort(d.date)} — {formatCurrencyWhole(d.total)}
          </option>
        ))}
      </select>
    </div>

    {needsReason && (
      <CreditCloseReasonPicker
        value={modal.reason || ''}
        note={modal.note || ''}
        onChange={onSetReason}
        onNoteChange={onSetNote}
      />
    )}

    <div className="modal-actions">
      <button className="btn btn-secondary" onClick={onClose}>ביטול</button>
      <button className="btn btn-success" onClick={onConfirm} disabled={!canConfirm}>
        <Icon name="check" size={16} /> אשר קבלה
      </button>
    </div>
    </Modal>
  );
}
